<template>
    <div class="layout" id="preciosClienteModulo">
        <div class="box-titulo">PRECIOS PARA FACTURACIÓN POR CLIENTE</div>

        <div class="box-container">
            <!-- FILTROS Y FORMULARIO -->
            <div class="box-filtres">
                <!-- FILA 1: CLIENTE + BOTÓN CARGAR PRECIOS -->
                <div class="row-cliente">
                    <div class="field-group">
                        <label class="field-label">CLIENTE</label>
                        <div class="field-inline">
                            <div class="field-grow">
                                <Select2 v-model="cliente_unique" :options="clientes" />
                            </div>
                            <button class="btn btn-secondary btn-sm ml-5" @click="cargarPreciosCliente"
                                :disabled="!cliente_unique || loading">
                                Cargar precios
                            </button>
                        </div>
                    </div>
                </div>

                <!-- FILA 2: PRODUCTO, PRECIO, MES, BOTÓN AGREGAR -->
                <div class="row-producto">
                    <div class="field-grid">
                        <div class="field-item field-lg">
                            <label class="field-label">PRODUCTO</label>
                            <Select2 v-model="selected_product" :options="lista_productos" />
                        </div>

                        <div class="field-item field-sm">
                            <label class="field-label">PRECIO CLIENTE</label>
                            <input v-model="precio_producto" class="form-control text-right" type="number" min="0"
                                step="0.01" placeholder="0.00" />
                        </div>

                        <div class="field-item field-sm">
                            <label class="field-label">MES</label>
                            <input v-model="mes" type="month" class="form-control" />
                        </div>

                        <div class="field-item field-actions">
                            <label class="field-label">&nbsp;</label>
                            <button class="btn btn-primary btn-sm" @click="guardarPrecio"
                                :disabled="!cliente_unique || !selected_product || !precio_producto || !mes || loading">
                                Agregar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABLA DE PRECIOS DEL CLIENTE -->
            <div class="box-lista" v-if="precios_cliente && precios_cliente.length > 0">
                <div class="box-subtitulo">
                    Precios configurados para:
                    <strong>{{ nombreClienteDesdePrecios }}</strong>
                </div>

                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th style="width: 100px" class="text-center">Mes</th>
                            <th style="width: 100px">Código</th>
                            <th>Producto</th>
                            <th style="width: 90px" class="text-right">Precio</th>
                            <th style="width: 80px" class="text-center">Unidad</th>
                            <th style="width: 100px" class="text-center">Registro</th>
                            <th style="width: 200px" class="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="7" class="text-center">
                                Cargando información...
                            </td>
                        </tr>

                        <tr v-else-if="precios_cliente.length === 0">
                            <td colspan="7" class="text-center">
                                No hay precios configurados para este cliente.
                            </td>
                        </tr>

                        <tr v-for="(item, index) in precios_cliente" :key="item._id">
                            <td class="text-center">
                                {{ obtenerMesDesdeFecha(item.fecha_inicio) }}
                            </td>
                            <td>
                                {{ item.producto_plu }}
                            </td>
                            <td>
                                {{ item.producto_descripcion }}
                            </td>
                            <td class="text-right">
                                {{ formatoMoney(item.precio) }}
                            </td>
                            <td class="text-center">
                                {{ item.unidad_codigo }}
                            </td>
                            <td class="text-center">
                                {{ item.registro_fecha }}
                            </td>
                            <td class="text-center">
                                <button class="btn btn-warning btn-xs mr-5" @click="editarPrecio(item)">
                                    Editar
                                </button>
                                <button class="btn btn-danger btn-xs" @click="eliminarPrecio(item, index)">
                                    Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Si hay cliente seleccionado pero aún no se han cargado precios -->
            <div class="box-lista" v-else-if="cliente_unique && !loading && precios_cliente.length === 0">
                <div class="box-subtitulo">
                    Precios configurados para:
                    <strong>{{ clienteSeleccionadoNombre || 'Cliente sin nombre' }}</strong>
                </div>
                <div class="text-center" style="padding: 10px;">
                    No hay precios configurados para este cliente.
                </div>
            </div>
        </div>

        <!-- MODAL EDICIÓN -->
        <div v-if="editModal.show" class="modal-backdrop">
            <div class="modal-dialog-custom">
                <div class="modal-header-custom">
                    <h5>Editar precio del cliente</h5>
                    <button type="button" class="close-btn" @click="closeEditModal" :disabled="editModal.loading">
                        &times;
                    </button>
                </div>

                <div class="modal-body-custom">
                    <div class="modal-row">
                        <strong>Cliente:</strong>
                        <span>{{ editModal.clienteNombre }}</span>
                    </div>
                    <div class="modal-row">
                        <strong>Producto:</strong>
                        <span>{{ editModal.productoNombre }}</span>
                    </div>

                    <div class="modal-row">
                        <label>Precio</label>
                        <input v-model="editModal.precio" class="form-control text-right" type="number" min="0"
                            step="0.01" />
                    </div>

                    <div class="modal-row">
                        <label>Mes</label>
                        <input v-model="editModal.mes" type="month" class="form-control" />
                    </div>
                </div>

                <div class="modal-footer-custom">
                    <button class="btn btn-secondary btn-sm" @click="closeEditModal" :disabled="editModal.loading">
                        Cancelar
                    </button>
                    <button class="btn btn-primary btn-sm ml-5" @click="guardarPrecioEdicion"
                        :disabled="editModal.loading || !editModal.precio || !editModal.mes">
                        {{ editModal.loading ? 'Guardando...' : 'Guardar cambios' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import FacturadorService from "../Facturador/FacturadorService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
    name: "PreciosClienteModulo",
    components: { Select2 },

    data() {
        return {
            GLOBAL,
            person: null,
            facturadorService: null,
            clienteService: null,

            loading: false,

            // Clientes
            clientes: [],
            cliente_unique: null,

            // Productos
            lista_productos: [],
            selected_product: null,

            // Formulario de precio (alta)
            precio_producto: null,
            mes: null,

            // Lista de precios por cliente (tercero)
            precios_cliente: [],

            // Modal de edición
            editModal: {
                show: false,
                loading: false,
                itemId: null,
                // aquí guardaremos el tercero_uniqueid
                tercero_uniqueid: null,
                clienteNombre: "",
                producto_id: null,
                productoNombre: "",
                precio: null,
                mes: null,
            },
        };
    },

    computed: {
        clienteSeleccionadoNombre() {
            const cli = this.clientes.find((c) => c.id === this.cliente_unique);
            return cli ? cli.text : "";
        },

        // AHORA usa tercero_uniqueid en lugar de tercero_id
        nombreClienteDesdePrecios() {
            if (!this.precios_cliente || this.precios_cliente.length === 0) {
                return this.clienteSeleccionadoNombre;
            }
            const terceroUniqueId = this.precios_cliente[0].tercero_uniqueid;
            const cli = this.clientes.find(
                (c) => Number(c.id) === Number(terceroUniqueId)
            );
            return cli ? cli.text : this.clienteSeleccionadoNombre;
        },
    },

    created() {
        this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
        this.clienteService = new ClienteService();
        this.facturadorService = new FacturadorService();
    },

    mounted() {
        this.getListaCliente();
        this.getListaProductos();
    },

    methods: {
        formatoMoney(value) {
            return this.GLOBAL.FORMATO_MONEY
                ? this.GLOBAL.FORMATO_MONEY(value)
                : Number(value || 0).toFixed(2);
        },

        getListaCliente() {
            this.loading = true;
            this.clienteService
                .getReporteClientes(this.person)
                .then((data) => {
                    this.clientes = [];
                    for (const i in data) {
                        this.clientes.push({
                            id: String(data[i]._id),
                            text: `${data[i].identificacion} - ${data[i].nombres}`,
                            nit: data[i].identificacion,
                            nombres: data[i].nombres,
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getListaProductos() {
            this.loading = true;
            this.facturadorService
                .getProductos(this.person)
                .then((response) => {
                    const body = response?.data || response || [];
                    const productos = Array.isArray(body) ? body : body.data || [];

                    this.lista_productos = productos.map((product) => ({
                        id: String(product._id),
                        text: `${product.plu} - ${product.descripcion}`,
                        plu: product.plu,
                        descripcion: product.descripcion,
                        precio: product.precio,
                        impuesto: !!product.impuesto,
                        unidad_id: product.unidad_id,
                        unidad_codigo: product.unidad_codigo,
                        unidad_descripcion: product.unidad_descripcion,
                        registro_fecha: product.registro_fecha,
                    }));
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        cargarPreciosCliente() {
            if (!this.cliente_unique) {
                alert("Debe seleccionar un cliente para cargar los precios.");
                return;
            }

            this.loading = true;
            this.facturadorService
                .getPreciosCliente(this.person, this.cliente_unique)
                .then((response) => {
                    const body = response?.data || response || [];
                    this.precios_cliente = Array.isArray(body) ? body : body.data || [];
                })
                .catch((err) => {
                    console.error("Error cargando precios cliente:", err);
                    this.precios_cliente = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        calcularRangoFechasDesdeMes(mesStr) {
            const [yearStr, monthStr] = mesStr.split("-");
            const year = parseInt(yearStr, 10);
            const month = parseInt(monthStr, 10);

            const fechaInicio = `${yearStr}-${monthStr}-01`;
            const lastDayDate = new Date(year, month, 0);
            const lastDay = String(lastDayDate.getDate()).padStart(2, "0");
            const fechaFinal = `${yearStr}-${monthStr}-${lastDay}`;

            return { fechaInicio, fechaFinal };
        },

        obtenerMesDesdeFecha(fechaStr) {
            if (!fechaStr || typeof fechaStr !== "string") return "";
            return fechaStr.substring(0, 7);
        },

        guardarPrecio() {
            if (
                !this.cliente_unique ||
                !this.selected_product ||
                !this.precio_producto ||
                !this.mes
            ) {
                alert("Debe seleccionar cliente, producto, precio y mes.");
                return;
            }

            const productoIdForm = Number(this.selected_product);
            const { fechaInicio, fechaFinal } =
                this.calcularRangoFechasDesdeMes(this.mes);

            const mesActual = this.mes;

            const existeDuplicado = this.precios_cliente.some((p) => {
                const mesRegistro = this.obtenerMesDesdeFecha(p.fecha_inicio);
                const productoIdRegistro = Number(p.producto_id);
                return (
                    productoIdRegistro === productoIdForm && mesRegistro === mesActual
                );
            });

            if (existeDuplicado) {
                alert(
                    "Ya existe un precio configurado para ese producto en el mes seleccionado."
                );
                return;
            }

            const payload = {
                _id: null,
                // aquí sigues mandando el id numérico que usa el backend
                tercero_uniqueid: (this.cliente_unique),
                producto_id: Number(this.selected_product),
                precio: Number(this.precio_producto),
                fecha_inicio: fechaInicio,
                fecha_final: fechaFinal,
            };

            this.loading = true;

            this.facturadorService
                .guardarPrecioCliente(this.person, payload)
                .then(() => {
                    this.cargarPreciosCliente();
                    this.precio_producto = null;
                    this.mes = null;
                })
                .catch((err) => {
                    console.error("Error guardando precio cliente:", err);
                    alert("No fue posible guardar el precio. Ver consola.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // ==== MODAL EDICIÓN ====
        editarPrecio(item) {

            this.editModal.show = true;
            this.editModal.loading = false;
            this.editModal.itemId = item._id;

            // guardamos el uniqueid para luego usarlo en el payload
            this.editModal.tercero_uniqueid = item.tercero_uniqueid;
            this.editModal.clienteNombre = this.clienteSeleccionadoNombre;

            this.editModal.producto_id = item.producto_id;
            this.editModal.productoNombre = item.producto_descripcion;
            this.editModal.precio = item.precio;
            this.editModal.mes = this.obtenerMesDesdeFecha(item.fecha_inicio);

            console.log(this.editModal)
        },

        closeEditModal() {
            this.editModal.show = false;
            this.editModal.loading = false;
            this.editModal.itemId = null;
            this.editModal.tercero_uniqueid = null;
            this.editModal.clienteNombre = "";
            this.editModal.producto_id = null;
            this.editModal.productoNombre = "";
            this.editModal.precio = null;
            this.editModal.mes = null;
        },

        guardarPrecioEdicion() {
            if (!this.editModal.itemId || !this.editModal.tercero_uniqueid) {
                alert("No se encontró el registro a editar.");
                return;
            }

            if (!this.editModal.precio || !this.editModal.mes) {
                alert("Debe diligenciar el precio y el mes.");
                return;
            }

            const { fechaInicio, fechaFinal } =
                this.calcularRangoFechasDesdeMes(this.editModal.mes);
            const productoIdForm = Number(this.editModal.producto_id);

            const existeDuplicado = this.precios_cliente.some((p) => {
                if (p._id === this.editModal.itemId) return false;
                const mesRegistro = this.obtenerMesDesdeFecha(p.fecha_inicio);
                const productoIdRegistro = Number(p.producto_id);
                return (
                    productoIdRegistro === productoIdForm &&
                    mesRegistro === this.editModal.mes
                );
            });

            if (existeDuplicado) {
                alert(
                    "Ya existe un precio configurado para ese producto en el mes seleccionado."
                );
                return;
            }

            const payload = {
                _id: this.editModal.itemId,
                // aquí usamos el valor que vino desde tercero_uniqueid
                tercero_uniqueid: this.editModal.tercero_uniqueid,
                producto_id: productoIdForm,
                precio: Number(this.editModal.precio),
                fecha_inicio: fechaInicio,
                fecha_final: fechaFinal,
            };

            this.editModal.loading = true;

            this.facturadorService
                .guardarPrecioCliente(this.person, payload)
                .then(() => {
                    this.cargarPreciosCliente();
                    this.closeEditModal();
                })
                .catch((err) => {
                    console.error("Error editando precio cliente:", err);
                    alert("No fue posible actualizar el precio. Ver consola.");
                })
                .finally(() => {
                    this.editModal.loading = false;
                });
        },

        eliminarPrecio(item, index) {
            if (!confirm("¿Desea eliminar este precio para el cliente?")) {
                return;
            }

            this.loading = true;

            // Armamos el payload con los 3 datos que pide el backend
            const payload = {
                _id: item._id,                                 // id del registro de precios_por_cliente
                tercero_uniqueid: item.tercero_uniqueid || this.cliente_unique, // por si viene del item o del select
                producto_id: item.producto_id,                 // id del producto
            };

            this.facturadorService
                .eliminarPrecioCliente(this.person, payload)
                .then(() => {
                    // Quitamos el registro de la tabla en el frontend
                    this.precios_cliente.splice(index, 1);

                    // Si justo se está editando ese registro, cerramos el modal
                    if (this.editModal.show && this.editModal.itemId === item._id) {
                        this.closeEditModal();
                    }
                })
                .catch((err) => {
                    console.error("Error eliminando precio cliente:", err);
                    alert("No fue posible eliminar el registro.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

    },
};
</script>


<style scoped>
/* ===== NUEVO LAYOUT FILTROS ===== */
.row-cliente {
    margin-bottom: 10px;
}

.field-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.field-label {
    font-size: 12px;
    font-weight: 600;
    color: #4b5563;
}

.field-inline {
    display: flex;
    align-items: center;
}

.field-grow {
    flex: 1 1 auto;
}

/* Segunda línea en grid: producto, precio, mes, botón */
.row-producto {
    margin-top: 5px;
}

.field-grid {
    display: grid;
    grid-template-columns: 1.5fr 0.8fr 0.8fr auto;
    gap: 8px;
}

.field-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.field-lg {
    min-width: 220px;
}

.field-sm {
    min-width: 120px;
}

.field-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

/* =============================== */

.ml-5 {
    margin-left: 5px;
}

.mr-5 {
    margin-right: 5px;
}

/* ===== Modal simple ===== */
.modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-dialog-custom {
    background: #ffffff;
    border-radius: 6px;
    width: 420px;
    max-width: 95%;
    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.3);
    overflow: hidden;
}

.modal-header-custom {
    padding: 10px 14px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-header-custom h5 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
}

.close-btn {
    border: none;
    background: transparent;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
}

.modal-body-custom {
    padding: 10px 14px;
    font-size: 13px;
}

.modal-row {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
}

.modal-row strong {
    margin-bottom: 2px;
}

.modal-row label {
    font-weight: 600;
    margin-bottom: 2px;
}

.modal-footer-custom {
    padding: 8px 14px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
}
</style>
